var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-grid-vue',{staticClass:"ag-theme-alpine",staticStyle:{"width":"100%","height":"570px","margin-top":"-30px"},attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"defaultColDef":_vm.defaultColDef,"getContextMenuItems":_vm.getContextMenuItems,"tooltipShowDelay":1000,"tooltipHideDelay":3000}})
}
var staticRenderFns = []

export { render, staticRenderFns }